import Icon from '@concur/nui-widgets/lib/Icon/Icon';
import withThemeStyles from '@concur/react-ui-theming/lib/utils/withThemeStyles';
import classNamesBind from 'classnames/bind';
import React from 'react';
import ScreenReaderMessageQueue from '../utils/ScreenReaderMessageQueue';
import * as styles from './SiteBanner-*.css';

const CSS_BLOCK = 'sapcnqr-site-banner';

const SiteBanner = React.forwardRef(({
    accentColor,
    classNameMap,
    iconName,
    sticky,
    stickyFrame,
    text,
    ...props
}, ref) => {
    const classnames = classNamesBind.bind(classNameMap);
    return (
        <>
            <div
                {...props}
                className={classnames(
                    CSS_BLOCK,
                    `${CSS_BLOCK}--accent-color-${accentColor}`,
                    {
                        [`${CSS_BLOCK}--sticky`]: sticky,
                    },
                )}
                ref={ref}
            >
                <Icon
                    ariaHidden
                    className={classnames(
                        `${CSS_BLOCK}__icon`,
                    )}
                    iconName={iconName}
                    size="md"
                />
                {text}
                <ScreenReaderMessageQueue announcement={text} />
            </div>
            {stickyFrame
            && (
                <div
                    className={classnames(
                        `${CSS_BLOCK}__sticky-frame`,
                        `${CSS_BLOCK}__sticky-frame--accent-color-${accentColor}`,
                    )}
                />
            )}
        </>
    );
});

export default withThemeStyles(styles)(SiteBanner);
